export const generalPanelName = 'General';
export const InputDataPanelName = 'Input Data';
export const OutputDataPanelName = 'Output Data';
export const advancedPanelName = 'Advanced';
export const flowParametersPanelName = 'Flow Parameters';
